import axios from "axios";
//import config from "../config/config.json"

export const getCheckout = async (request,tokenClient,apiToken) => {
/*   const request = {"items": [
            {
            "location": "/offers/point-to-point/searches/2a8c891c-6555-41b7-8627-f24c39423ca9/offers/6e04180b-b6d9-4e2b-a7c4-5953a9f9bf29"
            }   
        ]
   } */

  let config = require(`../config/${tokenClient}/config.json`);

  const headers = {
    'Content-Type': "application/json",
    'token': apiToken
  };

  const url = config.credential.api.url+'checkout';
            
  const response = await axios.post(url,JSON.stringify(request),{headers:headers})
  //const response = await axios.post(url)
    .then(res => {

      return res;
    })
    .catch((err) => {

      return false;
    }); 

  return response;
}